import * as actions from './actions';

const initialState = {
  // Compra anónima por lectura (espejo de suenos)
  pendingReadingId: null,
  pendingLoading: false,
  checkoutLoading: false,
  checkoutError: null,
  purchaseVerified: false,
  paidReadingId: null,
  paidEmail: null,
  verifyLoading: false,
};

export default function sinastriaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_PENDING_SINASTRIA_REQUEST:
      return { ...state, pendingLoading: true, pendingReadingId: null, checkoutError: null };
    case actions.CREATE_PENDING_SINASTRIA_SUCCESS:
      return { ...state, pendingLoading: false, pendingReadingId: action.payload.readingId };
    case actions.CREATE_PENDING_SINASTRIA_FAILURE:
      return { ...state, pendingLoading: false, checkoutError: action.payload };

    case actions.SINASTRIA_CHECKOUT_REQUEST:
    case actions.SINASTRIA_PAYPAL_REQUEST:
      return { ...state, checkoutLoading: true, checkoutError: null };
    case actions.SINASTRIA_CHECKOUT_SUCCESS:
    case actions.SINASTRIA_PAYPAL_SUCCESS:
      return { ...state, checkoutLoading: false };
    case actions.SINASTRIA_CHECKOUT_FAILURE:
    case actions.SINASTRIA_PAYPAL_FAILURE:
      return { ...state, checkoutLoading: false, checkoutError: action.payload };

    case actions.SINASTRIA_VERIFY_REQUEST:
    case actions.SINASTRIA_VERIFY_PAYPAL_REQUEST:
      return { ...state, verifyLoading: true, checkoutError: null };
    case actions.SINASTRIA_VERIFY_SUCCESS:
    case actions.SINASTRIA_VERIFY_PAYPAL_SUCCESS:
      return {
        ...state,
        verifyLoading: false,
        purchaseVerified: true,
        paidReadingId: action.payload.reading_id,
        paidEmail: action.payload.email,
      };
    case actions.SINASTRIA_VERIFY_FAILURE:
    case actions.SINASTRIA_VERIFY_PAYPAL_FAILURE:
      return { ...state, verifyLoading: false, checkoutError: action.payload };

    case actions.SINASTRIA_PURCHASE_RESET:
      return { ...initialState };

    default:
      return state;
  }
}
